<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

import NavHeader from "@/components/general/NavHeader.vue";
import { appStore } from "@/stores/AppStore";

const route = useRoute();
const store = appStore();

const autoSignIn = async (): Promise<void> => {
  await store.autoSignIn("completion");
};

const isCompletionContainerView = computed(
  () => typeof route.name === "string" && route.name.includes("CompletionContainerView"),
);

autoSignIn();
</script>

<template>
  <div class="safe-area-bot min-h-screen bg-neutral-800 flex flex-col">
    <NavHeader v-if="!isCompletionContainerView" app-name="completion" title="Kompletace" />
    <div
      class="flex flex-col flex-auto"
      :class="{
        'px-4 lg:px-8 py-6': !isCompletionContainerView,
        // pokud je to view containeru, tak se přidá padding kvůli rozdílnému layoutu
      }"
    >
      <router-view />
      <DynamicDialog />
      <Toast />
    </div>
  </div>
</template>
